module.exports = __webpack_public_path__ + "img/004任向军.11404f7f.png";